import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from '../../../errors/api-error-handler';
import { RightSideTrailInitialStateType, RightSideTrailNewsType, RightSideTrailType } from "../../../models/right-side-trail-model";
import EventRightSideNewsService from '../../../services/right-side/event-right-side-news.service';

const initialState: RightSideTrailInitialStateType = {
    rightSideFeaturedBooksData: [],
    rightSideFeaturedLearningData: [],
    rightSideTrendingNewsData: [],
    rightSidePopularEventsData: [],
    Loading: true,
    Error: undefined,
};

export const retrieveEventRightSideNews = createAsyncThunk('EventRightSideNews/retrieve',
    async (eventPath: string, { rejectWithValue }) => {
        try {

            const response = await EventRightSideNewsService.getEventRightSideNewsService(eventPath)
            return [response.data]

        } catch (error: any) {
            if (!error.response) {
                throw error
            }
            return rejectWithValue(error.response.status)
        }
    }
)

const EventRightSideNewsSlice = createSlice({
    name: 'EventRightSideNews',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(retrieveEventRightSideNews.pending, (state) => {
                state.Loading = true;
            })
            .addCase(retrieveEventRightSideNews.fulfilled, (state, action) => {
                if (action.payload) {
                    state.Loading = false;
                    state.rightSideTrendingNewsData = action.payload as RightSideTrailNewsType[];
                }
            })
            .addCase(retrieveEventRightSideNews.rejected, (state, { payload }) => {
                state.Loading = false;
                state.Error = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default EventRightSideNewsSlice.reducer;